import { ReactComponent as ChevronLeftIcon } from "assets/icons/chevron-left.svg";
import { classNames } from "helpers/ClassNameHelper";
import { handleKeyDown } from "modules/common/utils/keyboardUtils";
import { ReactNode } from "react";

interface Props {
    title?: string;
    hasBackButton?: boolean;
    onBackButtonClicked?: () => void;
    name?: string;
    after?: ReactNode;
    children: React.ReactNode;
}

export const HeaderFilter = ({
    title,
    name,
    hasBackButton,
    children,
    onBackButtonClicked,
    after,
}: Props) => {
    return (
        <div className={classNames("header-filter-container", name && `${name}-filter`)}>
            <div className="header-filter">
                {hasBackButton && (
                    <>
                        <div className="header-filter-back-button">
                            <div
                                className="header-filter-round-button"
                                onClick={onBackButtonClicked}
                                tabIndex={0}
                                onKeyDown={e => onBackButtonClicked && handleKeyDown(e, onBackButtonClicked)}

                            >
                                <ChevronLeftIcon />
                            </div>
                            <span className="back-button-text">NATRAG</span>
                        </div>
                        <div className="header-filter-separator" />
                    </>
                )}
                {title && (
                    <>
                        <div className="header-filter-title">{title}</div>
                        <div className="header-filter-separator" />
                    </>
                )}
                <div className="header-filter-options">{children}</div>
            </div>
            {after && <div className="header-filter-after">{after}</div>}
        </div>
    );
};
